import SpawnPoint from '@/cells/SpawnPoint'
import { RIGHT } from '@/constants/Directions'

export default class SpawnPointToRight extends SpawnPoint {
    public defaultDirection = RIGHT
}
